function trim(value: string | undefined): string | undefined {
  const nextValue = value?.trim();
  return nextValue ? nextValue : undefined;
}

function normalizeHttpUrl(rawValue: string, label: string): string {
  try {
    const url = new URL(rawValue);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      throw new Error(`${label} must use http or https`);
    }

    return url.toString().replace(/\/$/, "");
  } catch (error) {
    throw new Error(
      `${label} must be a valid absolute URL. Received: "${rawValue}"`,
      {
        cause: error,
      },
    );
  }
}

function normalizeWsUrl(rawValue: string, label: string): string {
  try {
    const url = new URL(rawValue);
    if (url.protocol !== "ws:" && url.protocol !== "wss:") {
      throw new Error(`${label} must use ws or wss`);
    }

    return url.toString().replace(/\/$/, "");
  } catch (error) {
    throw new Error(
      `${label} must be a valid absolute WebSocket URL. Received: "${rawValue}"`,
      {
        cause: error,
      },
    );
  }
}

function deriveWebSocketUrl(apiUrl: string): string {
  return `${apiUrl.replace(/^http/i, "ws")}/ws`;
}

const legacyApiBaseUrl = trim(import.meta.env.VITE_SIGNALING_URL);
const rawApiUrl = trim(import.meta.env.VITE_API_URL) || legacyApiBaseUrl;
const apiUrl = normalizeHttpUrl(rawApiUrl || "http://localhost:3001", "API");
const rawWsUrl =
  trim(import.meta.env.VITE_WS_URL) || deriveWebSocketUrl(apiUrl);

export const env = {
  apiUrl,
  wsUrl: normalizeWsUrl(rawWsUrl, "WebSocket URL"),
  stunUrl: trim(import.meta.env.VITE_STUN_URL) || "stun:stun.l.google.com:19302",
  stytchPublicToken: trim(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN),
  stytchCustomBaseUrl: trim(import.meta.env.VITE_STYTCH_CUSTOM_BASE_URL),
  stytchSessionMinutes: Number.parseInt(
    trim(import.meta.env.VITE_STYTCH_SESSION_MINUTES) || "525600",
    10,
  ),
  posthogHost: trim(import.meta.env.VITE_PUBLIC_POSTHOG_HOST),
  posthogKey: trim(import.meta.env.VITE_PUBLIC_POSTHOG_KEY),
} as const;
